import React from 'react';
import { Container } from '@material-ui/core';
import { withRouter } from 'react-router';
import VatReturnRequestForm from './components/request_form';

interface IProps {}
const VatReturnRequest: React.FC<IProps> = (props) => {
  // console.log('Render VatReturnRequest');
  return (
    <Container style={{ paddingTop: '2rem' }}>
      <VatReturnRequestForm />
    </Container>
  );
};

export default withRouter(VatReturnRequest);
